<template>
  <gdlSelect
    :value="value"
    :multiple="computedOpts.multiple"
    :filterable="computedOpts.filterable"
    :placeholder="computedOpts.placeholder"

    :options="options"
    :remote="computedOpts.remote"

    clearable
    size="small"
    transfer
    @change="$emit('change', $event)"
  />
</template>

<script>
import { merge } from 'lodash';
import gdlSelect from '@/components/gdl/inputs/gdlSelect.vue';

export default {
  name: 'SelectFilter',
  components: { gdlSelect },
  model: {
    event: 'change',
  },
  props: {
    value: { type: [Array, String], default: null },
    options: { type: Array, default: () => [] },
    opts: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      defaults: {
        multiple: true,
        filterable: true,
        placeholder: '',
      },
    };
  },
  computed: {
    computedOpts() {
      return merge({}, this.defaults, this.opts);
    },
  },
};
</script>

<style scoped>
</style>
